// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2Q4Xz","buttons":"SendReceipts_buttons__1XwMS","email":"SendReceipts_email__3IN4p","bookApptTitle":"SendReceipts_bookApptTitle__3Bqy5"};